import { render, staticRenderFns } from "./VideoItem.vue?vue&type=template&id=7b3ac7d9&"
import script from "./VideoItem.vue?vue&type=script&lang=ts&"
export * from "./VideoItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports